import { Component, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { Events, ModalController, NavController, NavParams, ToastController } from 'ionic-angular';
import { Http } from "@angular/http";
import { EbsWebService } from "../../services/ebsWebService";
import { EmailPage } from "../../pages/email/email";
import { WhatsappPage } from '../../pages/whatsapp/whatsapp';
import { CalendarDatePickerPopover } from '../../popovers/date-picker/calendar-datepicker';
import { SpeechInputPopover } from '../../popovers/speech-input/speech-input';
import { PopoverController } from 'ionic-angular';

@Component({
  selector: 'inputs',
  templateUrl: 'inputs.html',
  inputs: ['inputData']
})
export class InputPage implements AfterViewInit {


  dropdownList = [];
  selectedItems = [];
  dropdownSettings: any = {};
  dropdownLoadDataUrl: string;
  dropdownLoadDataParams: string;
  dropdownIsDataLoaded: boolean = false;

  dropdownHovered: boolean = false;
  dropdownOpened: boolean = false;

  inputData: any;
  dateValue: any;
  dropDownData: any = [];
  dropDownSelectedValue: any;
  GridBoxCaption: any

  accordionData: any;
  AccordionCaption: any;

  EmailCaption: any;

  selectOptions: any;

  speechRecognition: any;

  constructor(
    private cdRef: ChangeDetectorRef,
    public http: Http,
    public navCtrl: NavController,
    public navParams: NavParams,
    private _ebsWebService: EbsWebService,
    private toastCtrl: ToastController,
    public modalCtrl: ModalController,
    public events: Events,
    public popoverCtrl: PopoverController) {
    this.selectOptions = {
      title: 'Auswahl',
      mode: 'md'
    };
  }

  ngAfterViewInit(): void {
    this.dropdownSettings = {
      singleSelection: true,
      text: 'Auswahl',
      noDataLabel: 'Keine Daten vorhanden...',
      searchPlaceholderText: 'Suche...',
      enableSearchFilter: true,
      autoPosition: false
    };

    if (typeof this.inputData.DataType != "undefined" && this.inputData.DataType == "DropDown") {
      this.GridBoxCaption = this.inputData.LabelCaption;
      this.dropdownSettings.text = this.inputData.DisplayText;
      let action = this.inputData.ListItemAction.find(action => action.ActionName == 'GetData');
      if (action != undefined) {
        this.dropdownLoadDataUrl = action.ActionUrl;
        this.dropdownLoadDataParams = action.PostParameters;
      }

      if (this.inputData.Dynamic != null && this.inputData.Dynamic.ShowKeyboard != null) {
        this.dropdownSettings.searchAutofocus = this.inputData.Dynamic.ShowKeyboard == 'true' ? true : false;
      }

      //try {
      //  if (this.inputData.Dynamic != null && this.inputData.Dynamic.Searchable != null && this.inputData.Dynamic.Searchable == 'true') {
      //    let parsed = JSON.parse(this.inputData.EditValue);
      //    parsed.forEach(element => {
      //      let obj = { "id": element.Value, "itemName": element.Label };
      //      this.dropDownData.push(obj);
      //      if (element.IsSelected == "1") {
      //        this.selectedItems.push(obj);
      //      }
      //    });
      //  } else {
      //    this.dropDownData = JSON.parse(this.inputData.EditValue);
      //    for (let i = 0; i < this.dropDownData.length; i++) {
      //      if (this.dropDownData[i].IsSelected == 1) {
      //        this.dropDownSelectedValue = this.dropDownData[i].Label;
      //      }
      //    }
      //  }
      //} catch (e) {
      //  console.log("error", e);
      //}
    }


    if (typeof this.inputData.EditValue != "undefined" && this.inputData.EditValue != null) {
      this.dateValue = this.inputData.DisplayText;
      this.cdRef.detectChanges();
    }


    if (typeof this.inputData.DataType != "undefined" && this.inputData.DataType == "Accordion") {
      this.AccordionCaption = this.inputData.LabelCaption;
      try {
        console.log(this.inputData.EditValue);
        this.accordionData = JSON.parse(this.inputData.EditValue);

        //for (let i = 0; i < this.accordionData.length; i++) {
        //if (this.accordionData[i].IsSelected == 1) {
        //  this.dropDownSelectedValue = this.dropDownData[i].Label;
        //}
        //}
      } catch (e) {
        console.log("error", e);
      }
    }

    if (typeof this.inputData.EditValue != "undefined" && this.inputData.EditValue != null) {
      this.dateValue = this.inputData.DisplayText;
      this.cdRef.detectChanges();
    }


    if (typeof this.inputData.DataType != "undefined" && this.inputData.DataType == "EmailClient") {
      this.EmailCaption = this.inputData.LabelCaption;
    }

    if (typeof this.inputData.DataType != "undefined" && this.inputData.DataType == "System.Week") {
      this.inputData.EditValue = this.inputData.DisplayText.substring(0, 4) + "-W" + this.inputData.DisplayText.substring(4)
    }

    if (typeof this.inputData.DataType != "undefined" && this.inputData.DataType == "System.DateTime") {
      //this.inputData.EditValue = this.inputData.DisplayText.replace(/(\d{2}).(\d{2}).(\d{4}).*/, "$3-$2-$1");
      let split = this.inputData.DisplayText.split('.');
      this.inputData.EditValue = new Date(Number.parseInt(split[2]), Number.parseInt(split[1]), Number.parseInt(split[0]));
    }

    this.events.subscribe('inputs:datepickerset', (date, element) => {
      if (this.inputData == element) {
        let offset = date.getTimezoneOffset()
        date = new Date(date.getTime() - (offset * 60 * 1000))
        this.updateValue(date.toISOString().split('T')[0], element);
      }
    });

    this.events.subscribe('inputs:speechinput', (finalText, element) => {
      if (this.inputData == element) {
        this.inputData.DisplayText = finalText;
        this.updateValue(finalText, element)
      }
    });
  }

  openDatepicker(event) {
    let dateModal = this.modalCtrl.create(CalendarDatePickerPopover, {
      element: this.inputData,
      date: this.inputData.EditValue
    });
    dateModal.present();
  }

  openAccordion(event) {
    var acc = document.getElementsByClassName("accordion");
    for (let i = 0; i < acc.length; i++) {
      if (acc[i] != event.target) {
        continue;
      }
      acc[i].classList.toggle("active");
      var panel = (acc[i].nextElementSibling as HTMLElement);
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    }
  }

  changeValue(value, element) {
    let addedValue: number = +element.DisplayText + +value;
    this.inputData.DisplayText = addedValue;
    this.inputData.EditValue = addedValue;
    this.updateValue(addedValue, element);
  }

  updateValue(value, element) {
    console.log('NEW VALUE', value);
    console.log('element', element);


    if (typeof element.Action == "undefined" || element.Action == null) {
      console.error('Cant update value, Action or Params not available');
      return;
    }
    let params = element.PostParameters + value;

    console.log('params', params);

    let postPayloadObject = this._ebsWebService.buildPostPayloadObjectFromGetParameters(params);

    this._ebsWebService.postData(element.Action, postPayloadObject).toPromise().then(result => {
      if (result != null && typeof result != "undefined") {
        let toast = this.toastCtrl.create({
          message: result != undefined && result.Caption != undefined ? result.Caption : 'Erfolgreich gespeichert',
          duration: 5000,
          position: 'bottom'
        });
        toast.present();
      } else {
        let toast = this.toastCtrl.create({
          message: result != undefined && result.Caption != undefined ? result.Caption : "Fehler beim Speichern der Daten.",
          duration: 3000,
          position: 'bottom'
        });
        toast.present();
      }

      setTimeout(() => {
        this.events.publish("reloadMenu");
      }, 500);

      if (result.ViewType == 'Detail') {
        this.events.publish("detail:reloadPageWithResponse", result);
      } else if (result.ViewType == 'Table') {
        this.events.publish("table:reloadPageWithResponse", result);
      }

      console.log('updated heeeere');
    });
  }

  setDateValue(event) {
    console.log(event);
  }

  onOpenDropdown() {
    this.dropdownOpened = true;

    if (this.dropdownIsDataLoaded) {
      return;
    }

    console.log(this.dropdownLoadDataUrl);
    let postPayloadObject = this._ebsWebService.buildPostPayloadObjectFromGetParameters(this.dropdownLoadDataParams);
    this._ebsWebService.postData(this.dropdownLoadDataUrl, postPayloadObject).toPromise().then(result => {
      console.log(result, 'result');
      if (result != undefined) {
        this.dropdownIsDataLoaded = true;
        try {
          result.forEach(element => {
            let obj = { "id": element.value, "itemName": element.label };
            this.dropDownData.push(obj);
          });
        } catch (exception) {
          console.error(exception, 'Could not parse JSON string');
          console.error(result);
        }
      }
    });
  }

  onCloseDropdown() {
    this.dropdownOpened = false;
  }

  openEmailInterface(data) {
    let emailData = JSON.parse(data.EditValue);

    console.log('daaat', emailData);
    let profileModal = this.modalCtrl.create(EmailPage, {
      receiver: emailData.Receiver,
      subject: emailData.Subject,
      body: emailData.Body,
      data: data,
      fileAttachementCustom: emailData.FileAttachment || ''
    });
    profileModal.present();
  }

  openWhatsapp(data) {
    let parsedData = JSON.parse(data);
    console.log(parsedData);
    let profileModal = this.modalCtrl.create(WhatsappPage, {
      data: parsedData
    });
    profileModal.present();
  }

  openGoogleMapsLink(data) {
    let parsedData = JSON.parse(data);
    let baseLink = 'https://www.google.com/maps?saddr=My+Location&daddr=';
    let link = baseLink + encodeURIComponent(parsedData.street + ' ' + parsedData.plz + ' ' + parsedData.ort);
    window.open(link);
  }

  openSpeechModal(event) {
    let speechModal = this.modalCtrl.create(SpeechInputPopover, {
      element: this.inputData
    });
    speechModal.present();
  }

}



// WEBPACK FOOTER //
// ./src/components/inputs/inputs.ts